export function findAndReplace<T>(
  array: T[],
  findFunc: (item: T) => boolean,
  replacementValue: T,
) {
  const index = array.findIndex(findFunc);
  if (index >= 0) {
    array[index] = replacementValue;
  }
  return array;
}
